import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Bot, X } from 'lucide-react';
import ChatPanel from './ChatPanel';

/**
 * Floating chat bubble — bottom-right on every page.
 * Hides on /assistant (where the full-page ChatPanel is already visible) and on
 * /login and /register (auth pages).
 */
export default function AssistantBubble() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const hiddenOn = ['/assistant', '/login', '/register'];
  if (hiddenOn.some((p) => loc.pathname.startsWith(p))) return null;

  // Derive page context for the chatbot
  let page = 'map';
  let boothId = null;
  if (loc.pathname.startsWith('/booth/')) {
    page = 'booth';
    const m = loc.pathname.match(/\/booth\/(\d+)/);
    if (m) boothId = Number(m[1]);
  } else if (loc.pathname.startsWith('/schedule')) page = 'schedule';
  else if (loc.pathname.startsWith('/exhibitor')) page = 'exhibitor';
  else if (loc.pathname.startsWith('/admin')) page = 'admin';

  return (
    <>
      {open && (
        <div
          className="fixed inset-0 z-[70] bg-black/40 backdrop-blur-sm md:hidden"
          onClick={() => setOpen(false)}
        />
      )}
      <div className={`fixed z-[80] transition-all duration-200 ${
        open
          ? 'inset-x-4 top-20 bottom-20 md:inset-x-auto md:bottom-24 md:right-6 md:top-auto md:w-[420px] md:h-[600px]'
          : 'bottom-24 right-4 md:bottom-6 md:right-6 w-14 h-14'
      }`}>
        {open ? (
          <div className="relative h-full">
            <button
              onClick={() => setOpen(false)}
              className="absolute -top-3 -right-3 z-10 w-8 h-8 rounded-full bg-slate-800 hover:bg-slate-700 border border-slate-600 text-white grid place-items-center shadow-lg"
              data-testid="chat-close-btn"
            >
              <X className="w-4 h-4" />
            </button>
            <ChatPanel compact page={page} boothId={boothId} />
          </div>
        ) : (
          <button
            onClick={() => setOpen(true)}
            className="group relative w-14 h-14 rounded-full bg-gradient-to-br from-emerald-500 to-cyan-500 hover:from-emerald-400 hover:to-cyan-400 shadow-lg shadow-emerald-500/40 grid place-items-center transition-transform hover:scale-110"
            title="Ask Landi — AI Tour Guide"
            data-testid="assistant-bubble"
            aria-label="Open AI Assistant"
          >
            <span className="absolute inset-0 rounded-full bg-emerald-500/40 animate-ping opacity-60" />
            <Bot className="relative w-7 h-7 text-white" />
          </button>
        )}
      </div>
    </>
  );
}
